import AdminHolidaysContent from "../../../components/Admin/Holidays"

const AdminHolidays = () => {

    return (
        <>
            <AdminHolidaysContent />
        </>
    )

}

export default AdminHolidays